import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-4"
}
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-row-dashed table-row-gray-300 <!-- align-middle --> gs-0 gy-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, "STT"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"120px"} }, "Tên vật tư"),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"100px"},
    class: "text-left"
  }, "Đơn vị tính"),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"50px"},
    class: "text-end"
  }, "Số lượng"),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"100px"},
    class: "text-end"
  }, "Còn lại trong kho"),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"100px"},
    class: "text-end"
  }, "Đơn giá"),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"width":"100px"},
    class: "text-end"
  }, "Thành tiền")
], -1)
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "pe-0" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "pe-0" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "pe-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  class: "py-0",
  colspan: "2"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  class: "py-0",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("h4", { class: "ps-0 text-end" }, "Tổng cộng")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", { class: "py-0" }, null, -1)
const _hoisted_17 = { class: "py-0 text-end" }
const _hoisted_18 = { class: "ps-0 pe-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", {
  class: "py-0",
  colspan: "2"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", {
  class: "py-0",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "ps-0 text-end" }, " Tổng tiền bằng chữ ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { class: "py-0" }, null, -1)
const _hoisted_22 = { class: "py-0 text-end" }
const _hoisted_23 = { class: "ps-0 pe-0" }
const _hoisted_24 = {
  key: 0,
  class: "mt-5 d-flex justify-content-end pe-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_custom = _resolveComponent("button-custom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.isPhieuXuatLe)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(item.ten_kho) + ": ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.vat_tu_da_lay, (supply, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(supply.ten_vat_tu), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(supply.don_vi_tinh ? supply.don_vi_tinh : ""), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("strong", _hoisted_8, _toDisplayString(supply.so_luong_lay), 1)
                  ]),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(supply.con_lai.toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("strong", _hoisted_11, _toDisplayString(_ctx.formatCurrencyAndQuantity(supply.don_gia)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.formatCurrencyAndQuantity(Math.round(supply.don_gia * supply.so_luong_lay), false)), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("th", _hoisted_17, [
                  _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.formatCurrencyAndQuantity(Math.round(item.tong_tien), false)), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _createElementVNode("th", _hoisted_22, [
                  _createElementVNode("i", _hoisted_23, _toDisplayString(item.tong_tien_bang_chu), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
    }), 128)),
    (!_ctx.isViewOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_button_custom, {
            "button-type": _ctx.ButtonsType.TRASH,
            "color-type": _ctx.ButtonTypeColors.DANGER,
            onClick: _ctx.clearQuantityDataClickedHandler
          }, null, 8, ["button-type", "color-type", "onClick"]),
          _createVNode(_component_button_custom, {
            "color-type": _ctx.ButtonTypeColors.SUCCESS,
            "button-type": _ctx.ButtonsType.SAVE,
            onClick: _ctx.confirmButtonClickedHandler
          }, null, 8, ["color-type", "button-type", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}